// src/pages/VerificarDECA.jsx - DISEÑO COMO EN LAS IMÁGENES
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function VerificarDECA() {
  const { id } = useParams();
  const [decaData, setDecaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDecaData = async () => {
      try {
        if (!id) {
          setError("ID de DECA no válido");
          return;
        }

        const docRef = doc(db, "decas", id);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          setError("Documento DECA no encontrado");
          return;
        }

        const data = docSnap.data();
        setDecaData(data);
      } catch (err) {
        console.error("Error cargando DECA:", err);
        setError("Error al cargar el documento");
      } finally {
        setLoading(false);
      }
    };

    fetchDecaData();
  }, [id]);

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    try {
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return date.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    } catch {
      return "N/A";
    }
  };

  const getValue = (obj, path, defaultValue = 'N/A') => {
    try {
      return path.split('.').reduce((current, key) => current?.[key], obj) || defaultValue;
    } catch {
      return defaultValue;
    }
  };
  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: '#f5f7fa', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid #f3f4f6',
            borderTop: '3px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 24px'
          }}></div>
          <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>
            Verificando documento DECA...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: '#f5f7fa', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ 
          maxWidth: '500px', 
          textAlign: 'center', 
          background: 'white', 
          padding: '48px', 
          borderRadius: '12px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{ color: '#dc2626', marginBottom: '16px', fontSize: '24px', fontWeight: 600 }}>
            Error de Verificación
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '32px', fontSize: '16px' }}>{error}</p>
          <button onClick={() => window.location.href = "/"} style={{
            background: '#dc2626', 
            color: 'white', 
            border: 'none', 
            borderRadius: '8px',
            padding: '12px 24px', 
            fontSize: '14px', 
            fontWeight: 500, 
            cursor: 'pointer'
          }}>
            Volver al Inicio
          </button>
        </div>
      </div>
    );
  }

  if (!decaData) return null;
  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      {/* HEADER AZUL MARINO - RESPONSIVE */}
      <div style={{
        background: '#1e3a8a',
        padding: '14px 20px',
        color: 'white'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px'
        }}>
          {/* Logo camión + DeCA */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
            {/* Icono del camión */}
            <div style={{
              background: '#3b82f6',
              padding: '10px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
              </svg>
            </div>
            
            <div style={{ minWidth: 0 }}>
              <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', lineHeight: 1.2 }}>DeCA</h1>
              <div style={{ fontSize: '13px', opacity: 0.9, whiteSpace: 'nowrap' }}>
                Verificación documental
              </div>
            </div>
          </div>
          

        </div>
      </div>
      {/* CONTENIDO PRINCIPAL */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '32px 24px'
      }}>
        
        {/* BANNER VERDE DE VERIFICACIÓN - COMO EN LA IMAGEN */}
        <div style={{
          background: '#ecfdf5',
          border: '1px solid #10b981',
          borderRadius: '8px',
          padding: '16px 20px',
          marginBottom: '32px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <div style={{
            background: '#10b981',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '18px'
          }}>
            ✓
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#065f46' }}>
              Documento verificado
            </h3>
            <p style={{ margin: 0, fontSize: '14px', color: '#047857' }}>
              Este DeCA es válido y los datos coinciden con los registrados.
            </p>
          </div>
          <div style={{ marginLeft: 'auto', fontSize: '12px', color: '#047857' }}>
            Verificado el {formatDate(decaData.createdAt)} 10:24
          </div>
        </div>
        {/* SECCIÓN PRINCIPAL CON TÍTULO E INFORMACIÓN */}
        <div style={{
          marginBottom: '40px'
        }}>
          {/* COLUMNA IZQUIERDA - INFORMACIÓN */}
          <div>
            <h2 style={{
              fontSize: '32px',
              fontWeight: 'bold',
              color: '#1f2937',
              marginBottom: '16px',
              lineHeight: 1.2
            }}>
              Documento electrónico<br/>
              de control administrativo (DeCA)
            </h2>
            
            <p style={{
              fontSize: '16px',
              color: '#6b7280',
              marginBottom: '8px'
            }}>
              Este documento cumple con la Orden FOM/2861/2012 y es obligatorio desde el 5 de octubre de 2026.
            </p>
            
            <p style={{
              fontSize: '14px',
              color: '#6b7280',
              marginBottom: '32px'
            }}>
              Los datos mostrados son un resumen del documento. Para ver el documento completo, descargue el PDF.
            </p>

            {/* INFORMACIÓN DEL DOCUMENTO */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '32px',
              marginBottom: '32px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  background: '#dbeafe',
                  padding: '8px',
                  borderRadius: '8px',
                  color: '#1e40af'
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h8c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>
                  </svg>
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#3b82f6', fontWeight: '600' }}>Código DeCA</div>
                  <div style={{ fontSize: '16px', fontWeight: 'bold', fontFamily: 'monospace', color: '#111827' }}>
                    {getValue(decaData, 'codigoDECA')}
                  </div>
                </div>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{
                  background: '#dbeafe',
                  padding: '8px',
                  borderRadius: '8px',
                  color: '#1e40af'
                }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2-7h-3V2h-2v2H8V2H6v2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V8h14v10z"/>
                  </svg>
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#3b82f6', fontWeight: '600' }}>Fecha de emisión</div>
                  <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#111827' }}>
                    {formatDate(decaData.createdAt)}
                  </div>
                </div>
              </div>
            </div>
            {/* BOTONES DE ACCIÓN */}
            <div style={{ display: 'flex', gap: '16px' }}>
              {decaData.pdfUrl && (
                <a
                  href={decaData.pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: '#3b82f6',
                    color: 'white',
                    padding: '12px 24px',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                  </svg>
                  Descargar PDF
                </a>
              )}
              
              {decaData.pdfUrl && (
              <button
                onClick={() => window.open(decaData.pdfUrl, '_blank', 'noopener,noreferrer')}
                style={{
                  background: 'transparent',
                  color: '#3b82f6',
                  border: '2px solid #3b82f6',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                </svg>
                Visualizar PDF
              </button>
              )}
            </div>
          </div>


        </div>
        {/* TARJETAS DE INFORMACIÓN CON ICONOS - COMO EN LA IMAGEN */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '20px'
        }}>
          
          {/* DATOS DEL CARGADOR */}
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <div style={{
                background: '#dbeafe',
                padding: '8px',
                borderRadius: '8px',
                color: '#1e40af'
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937'
              }}>
                Datos del cargador
              </h3>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Nombre/Razón Social</div>
                <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                  {getValue(decaData, 'cargador.nombre')}
                </div>
              </div>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>CIF/NIF</div>
                <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                  {getValue(decaData, 'cargador.cif')}
                </div>
              </div>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Dirección</div>
                <div style={{ fontSize: '14px', color: '#1f2937' }}>
                  {getValue(decaData, 'cargador.direccion')}<br/>
                  {getValue(decaData, 'cargador.ciudad')} {getValue(decaData, 'cargador.codigoPostal')}
                </div>
              </div>
              {getValue(decaData, 'cargador.email') !== 'N/A' && (
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Email</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'cargador.email')}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* DATOS DEL TRANSPORTISTA */}
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <div style={{
                background: '#f3e8ff',
                padding: '8px',
                borderRadius: '8px',
                color: '#7c3aed'
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                </svg>
              </div>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937'
              }}>
                Datos del transportista
              </h3>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Nombre/Razón Social</div>
                <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                  {getValue(decaData, 'transportista.nombre')}
                </div>
              </div>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>CIF/NIF</div>
                <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                  {getValue(decaData, 'transportista.cif')}
                </div>
              </div>
              {getValue(decaData, 'transportista.licencia') !== 'N/A' && (
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Licencia</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'transportista.licencia')}
                  </div>
                </div>
              )}
              {getValue(decaData, 'transportista.email') !== 'N/A' && (
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Email</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'transportista.email')}
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* ORIGEN Y DESTINO */}
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <div style={{
                background: '#dcfce7',
                padding: '8px',
                borderRadius: '8px',
                color: '#059669'
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </div>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937'
              }}>
                Origen y destino
              </h3>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{
                  width: '8px',
                  height: '8px',
                  background: '#3b82f6',
                  borderRadius: '50%',
                  marginTop: '8px',
                  flexShrink: 0
                }}></div>
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Origen</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'origen.direccion')}<br/>
                    {getValue(decaData, 'origen.ciudad')} {getValue(decaData, 'origen.codigoPostal')}
                  </div>
                </div>
              </div>

              {/* Flecha entre origen y destino */}
              <div style={{ display: 'flex', alignItems: 'center', margin: '6px 0', gap: '12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '8px', flexShrink: 0 }}>
                  <div style={{ width: '2px', height: '8px', background: '#d1d5db' }}></div>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
                    <path d="M12 5v14M5 12l7 7 7-7" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div style={{ fontSize: '11px', color: '#9ca3af', fontStyle: 'italic' }}>hacia</div>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                <div style={{
                  width: '8px',
                  height: '8px',
                  background: '#10b981',
                  borderRadius: '50%',
                  marginTop: '8px',
                  flexShrink: 0
                }}></div>
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Destino</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'destino.direccion')}<br/>
                    {getValue(decaData, 'destino.ciudad')} {getValue(decaData, 'destino.codigoPostal')}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* DATOS DE LA MERCANCÍA */}
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <div style={{
                background: '#fef3c7',
                padding: '8px',
                borderRadius: '8px',
                color: '#d97706'
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z"/>
                </svg>
              </div>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937'
              }}>
                Datos de la mercancía
              </h3>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Descripción</div>
                <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                  {getValue(decaData, 'mercancia.descripcion')}
                </div>
              </div>
              {getValue(decaData, 'mercancia.peso') !== 'N/A' && (
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Peso</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'mercancia.peso')} kg
                  </div>
                </div>
              )}
              {getValue(decaData, 'mercancia.bultos') !== 'N/A' && (
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Bultos</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'mercancia.bultos')}
                  </div>
                </div>
              )}
              {getValue(decaData, 'mercancia.volumen') !== 'N/A' && (
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Volumen</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'mercancia.volumen')} m³
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* DATOS DEL VEHÍCULO Y CONDUCTOR */}
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <div style={{
                background: '#fee2e2',
                padding: '8px',
                borderRadius: '8px',
                color: '#dc2626'
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.22.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                </svg>
              </div>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937'
              }}>
                Datos del vehículo y conductor
              </h3>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Vehículo</div>
                <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                  - {getValue(decaData, 'vehiculo.matricula')}
                </div>
              </div>
              {getValue(decaData, 'vehiculo.conductor') !== 'N/A' && (
                <div>
                  <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Conductor</div>
                  <div style={{ fontSize: '14px', color: '#1f2937' }}>
                    {getValue(decaData, 'vehiculo.conductor')} -
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* FECHAS DEL TRANSPORTE */}
          <div style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '16px'
            }}>
              <div style={{
                background: '#f3e8ff',
                padding: '8px',
                borderRadius: '8px',
                color: '#7c3aed'
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2-7h-3V2h-2v2H8V2H6v2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V8h14v10z"/>
                </svg>
              </div>
              <h3 style={{
                margin: 0,
                fontSize: '16px',
                fontWeight: '600',
                color: '#1f2937'
              }}>
                Fechas del transporte
              </h3>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Recogida</div>
                <div style={{ fontSize: '14px', color: '#1f2937', fontWeight: '600' }}>
                  {getValue(decaData, 'fechaCarga') !== 'N/A' ? formatDate(decaData.fechaCarga) : '9 de octubre de 2026'} - 08:00
                </div>
              </div>
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Entrega</div>
                <div style={{ fontSize: '14px', color: '#1f2937' }}>
                  {getValue(decaData, 'fechaDescarga') !== 'N/A' ? formatDate(decaData.fechaDescarga) : '10 de octubre de 2026'} - 20:00
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ESTILOS PARA ANIMACIONES */}
      <style>{`
        @keyframes spin { 
          0% { transform: rotate(0deg); } 
          100% { transform: rotate(360deg); } 
        }
        @media (max-width: 640px) {
          .deca-nav {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}